var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoButton = function SvgInfoButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 45.999 45.999"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.264 6.736c-8.982-8.981-23.545-8.982-32.528 0s-8.981 23.545 0 32.528c8.982 8.98 23.545 8.981 32.528 0 8.981-8.983 8.98-23.545 0-32.528M25.999 33a3 3 0 1 1-6 0V21a3 3 0 1 1 6 0zm-3.053-17.128c-1.728 0-2.88-1.224-2.844-2.735-.036-1.584 1.116-2.771 2.879-2.771 1.764 0 2.88 1.188 2.917 2.771-.001 1.511-1.152 2.735-2.952 2.735"
  })));
};
export default SvgInfoButton;